import Phaser from 'phaser';
import EDC from '@/components/games/shared/globals';
import WandRays from './wand-rays';
import NameView from './name-view';
import NewName from './new-name';
import SaveName from './save-name';
import store from '@/store/index';
import router from '@/router/index';
import CursorManager from '@/components/games/shared/cursor-manager';
import Button from '@/components/games/shared/button';

/**
 *
 */
EDC.Games.NameSelect.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.NameSelect.Scenes.Main.prototype.init = function () {
  this.gameConfig = EDC.Games.NameSelect.Config;
  this.bg = null;
  this.content = null;
  this.title = null;
  this.nameWindow = null;
  this.nameView = null;
  this.newNameButton = null;
  this.saveNameButton = null;
  this.backButton = null;
  this.cursorManager = null;
  this.name = '';
  this.rays = null;
  this.backPos = { x: 100, y: 100 };
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.NameSelect.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  const logo = this.add.sprite(0, 0, 'logo').setScale(1.4);

  const titleFrame = this.add.sprite(0, 0, 'title-frame');
  titleFrame.setScale(1.2);
  titleFrame.setPosition(titleFrame.displayWidth / 2 + logo.displayWidth / 2,
    titleFrame.displayHeight / 2);

  this.title = this.add.sprite(logo.displayWidth / 2, 0, 'name-selection-title');

  this.nameWindow = this.add.sprite(0, 150, 'name-selection-window').setOrigin(0);
  this.nameWindow.setScale(1, 0.7);
  this.nameWindow.setAlpha(0);

  this.title.setScale(1.4);
  this.title.setPosition(titleFrame.x, titleFrame.y);
  // this.title.x += (this.nameWindow.displayWidth - this.title.displayWidth) / 2;

  logo.setPosition(185, titleFrame.displayHeight / 2);
  this.content.add([titleFrame, logo, this.title, this.nameWindow]);

  this.nameView = new NameView(this).create();

  this.newNameButton = new NewName(this).create(this.generateNewName.bind(this));
  this.saveNameButton = new SaveName(this).create(this.saveName.bind(this));

  this.rays = new WandRays(this).create();

  this.generateNewName();

  this.backButton = new Button(this, this.backPos.x, this.backPos.y).create('back-normal', 'back-hover');
  this.backButton.setClickCallback(this.onBackBtnClick.bind(this));

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};
/**
 *
 */
EDC.Games.NameSelect.Scenes.Main.prototype.saveName = function () {
  store.dispatch('children/updateNewProfile', { nickname: this.name });

  const url = new URL(window.location.href);
  if (url.searchParams.get('edit')) {
    this.editName(this.name);
  } else {
    const button = this.saveNameButton.getButton();
    this.tweens.add({
      targets: button,
      scaleX: '-=0.1',
      scaleY: '-=0.1',
      duration: 75,
      ease: 'Linear',
      yoyo: true,
    });
    this.cursorManager.resetCursor();
    this.input.enabled = false;
    this.time.delayedCall(500, this.nextScene, [], this);
  }
};

EDC.Games.NameSelect.Scenes.Main.prototype.nextScene = function () {
  this.scene.start('profileSummary');
};
/**
 *
 */
EDC.Games.NameSelect.Scenes.Main.prototype.onBackBtnClick = function () {
  const url = new URL(window.location.href);
  if (url.searchParams.get('edit') === 'name') {
    router.push({ name: 'profile' });
  } else {
    this.backToAvatar();
  }
};

EDC.Games.NameSelect.Scenes.Main.prototype.backToAvatar = function () {
  this.input.enabled = false;
  this.time.delayedCall(200, this.previousScene, [], this);
};

EDC.Games.NameSelect.Scenes.Main.prototype.previousScene = function () {
  this.scene.start('mainAvatar');
};
/**
 *
 */
EDC.Games.NameSelect.Scenes.Main.prototype.generateNewName = function () {
  const cfg = EDC.Games.NameSelect.Config;
  const targetFirstNames = cfg.names.firstNames;
  const targetLastNames = cfg.names.lastNames;

  const firstName = Phaser.Utils.Array.GetRandom(targetFirstNames);
  const lastName = Phaser.Utils.Array.GetRandom(targetLastNames);
  this.nameView.setName(firstName, lastName);
  const neededScale = this.content.scaleX;
  // eslint-disable-next-line max-len
  this.nameView.setPosition(this.content.x + this.nameWindow.x + (this.nameWindow.width * neededScale) / 2 - (this.nameView.getWidth() * neededScale) / 2 + 50,
    this.content.y + 50 + 250 * neededScale);
  this.name = `${firstName} ${lastName}`;
};
/**
 *
 */
// eslint-disable-next-line max-len
EDC.Games.NameSelect.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.8) / contentHeight;

  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2, (height - bounds.height) / 2);

  this.nameView.setScale(neededScale);
  this.nameView.setPosition(
    // eslint-disable-next-line max-len
    this.content.x + this.nameWindow.x + (this.nameWindow.width * neededScale) / 2 - (this.nameView.getWidth() * neededScale) / 2 + 50,
    this.content.y + 50 + 250 * neededScale,
  );

  this.newNameButton.setScale(neededScale);
  this.newNameButton.setPosition(this.content.x + 600 * neededScale + 50,
    this.content.y + 900 * neededScale + 50);

  this.saveNameButton.setScale(neededScale);
  this.saveNameButton.setPosition(this.content.x + 1450 * neededScale + 50,
    this.content.y + 1000 * neededScale + 50);

  this.rays.setScale(neededScale);
  this.rays.setPosition(this.content.x + 1020 * neededScale + 50,
    this.content.y + 680 * neededScale + 50);

  this.backButton.setScale(1, 1);
  const backSize = this.backButton.getSize();
  const backScaleX = (width * 0.07) / backSize.width;
  const backScaleY = (height * 0.07) / backSize.height;
  neededScale = backScaleX > backScaleY ? backScaleX : backScaleY;
  this.backButton.setScale(neededScale, neededScale);
  this.backButton.setPosition(this.backPos.x * neededScale, height - this.backPos.y * neededScale);
};

EDC.Games.NameSelect.Scenes.Main.prototype.editName = function () {
  store.dispatch('children/updateActiveChild').then(() => {
    router.push({ name: 'profile' });
  });
};

export default EDC.Games.NameSelect.Scenes.Main;
